import { useEffect, useState } from 'react'
import { API, Endpoints } from '@brg/api'

export enum ROLES {
  none = 'none',
  student = 'student',
  teacher = 'teacher',
  jury = 'jury',
}

type UseCoursesRoleResult = [ROLES, boolean, unknown];

export const useCoursesRole = (projectId?: string, longreadId?: string, disabled?: boolean): UseCoursesRoleResult => {
  const isEnabled = Boolean(projectId && longreadId && !disabled);

  const [isLoading, setIsLoading] = useState(isEnabled);
  const [error, setError] = useState<unknown>();
  const [response, setResponse] = useState<ROLES>(ROLES.none);

  const rolesMap: { [key: string]: ROLES } = {
    1: ROLES.student,
    2: ROLES.teacher,
    3: ROLES.jury,
  };

  useEffect(() => {
    if (!projectId || !longreadId || disabled) {
      setIsLoading(false);
      return;
    }

    let isActual = true;
    setIsLoading(true);

    API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/LMS/GetAccessType')
      .addQuery('projectId', projectId)
      .addQuery('themeLongreadId', longreadId)
      .get()
      .send()
      .then((r) => r.json())
      .then((r: number) => {
        if (!isActual) return;
        setResponse(rolesMap[r] ?? ROLES.none)
      })
      .catch((e) => {
        if (!isActual) return;
        setError(e)
      })
      .finally(() => {
        if (!isActual) return;
        setIsLoading(false)
      })

    return () => {
      isActual = false;
    }
  }, [projectId, longreadId, disabled])

  return [response, isLoading, error]
}
import { useEffect, useState } from 'react'
import { API, Endpoints } from '@brg/api'

export enum ROLES {
  none = 'none',
  student = 'student',
  teacher = 'teacher',
  jury = 'jury',
}

type UseCoursesRoleResult = [ROLES, boolean, unknown];

export const useCoursesRole = (projectId?: string, longreadId?: string, disabled?: boolean): UseCoursesRoleResult => {
  const isEnabled = Boolean(projectId && longreadId && !disabled);

  const [isLoading, setIsLoading] = useState(isEnabled);
  const [error, setError] = useState<unknown>();
  const [response, setResponse] = useState<ROLES>(ROLES.none);

  const rolesMap: { [key: string]: ROLES } = {
    1: ROLES.student,
    2: ROLES.teacher,
    3: ROLES.jury,
  };

  useEffect(() => {
    if (!projectId || !longreadId || disabled) {
      setIsLoading(false);
      return;
    }

    let isActual = true;
    setIsLoading(true);

    API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/LMS/GetAccessType')
      .addQuery('projectId', projectId)
      .addQuery('themeLongreadId', longreadId)
      .get()
      .send()
      .then((r) => r.json())
      .then((r: number) => {
        if (!isActual) return;
        setResponse(rolesMap[r] ?? ROLES.none)
      })
      .catch((e) => {
        if (!isActual) return;
        setError(e)
      })
      .finally(() => {
        if (!isActual) return;
        setIsLoading(false)
      })

    return () => {
      isActual = false;
    }
  }, [projectId, longreadId, disabled])

  return [response, isLoading, error]
}
